import { z } from '@harvestiq/zod';
import { RmaLgmTypeCodes } from '@harvestiq/constants';
import {
  zDecimalNullable,
  zDecimalRequired,
  zIsoDate,
  zCoercedBoolean,
} from '@harvestiq/zod';

// request
export const lgmIndemnityRequestSchema = z.object({
  coverages: z.array(
    z.object({
      typeCode: z.nativeEnum(RmaLgmTypeCodes),
      deductible: z.coerce.number().int(),
      referenceId: z.coerce.number().optional(),
      salesEffectiveDate: zIsoDate(),
      marketings: z.array(
        z.object({
          marketingDate: zIsoDate(),
          numberOfHead: z.coerce.number().min(0),
        })
      ),
      isPre2026BeginningFarmerRancher: zCoercedBoolean().optional(),
      isVeteranFarmerRancher: zCoercedBoolean().optional(),
      beginningFarmerRancherCropYearCount: z.coerce
        .number()
        .int()
        .nullable()
        .optional(),
      liveCattleTargetCwtPerHead: z.coerce.number().optional(),
      feederCattleTargetCwtPerHead: z.coerce.number().optional(),
      cornTargetBuPerHead: z.coerce.number().optional(),
    })
  ),
});

export type LgmIndemnityRequest = z.infer<typeof lgmIndemnityRequestSchema>;

// response
export const lgmIndemnityResponseSchema = z.object({
  data: z.array(
    z.object({
      typeCode: z.nativeEnum(RmaLgmTypeCodes),
      deductible: z.number().int(),
      referenceId: z.number().optional(),
      salesEffectiveDate: zIsoDate(),
      grossMarginGuaranteesPerHead: zDecimalRequired().array(),

      projectedGrossMarginsPerHead: zDecimalNullable().array(),
      projectedGrossMarginTotals: zDecimalNullable().array(),
      coverageProjectedGrossMarginTotal: zDecimalNullable(),

      actualGrossMarginsTotals: zDecimalNullable().array(),
      actualGrossMarginsPerHead: zDecimalNullable().array(),
      coverageActualGrossMarginTotal: zDecimalNullable(),

      coverageIndemnityPerHead: zDecimalRequired(),
      coverageIndemnityTotal: zDecimalRequired(),
      marketings: z.array(
        z.object({
          marketingDate: zIsoDate(),
          numberOfHead: z.number(),
        })
      ),
    })
  ),
});

export type LgmIndemnityResponse = z.infer<typeof lgmIndemnityResponseSchema>;
